webpackJsonp([114276838955818,60335399758886],{

/***/ 164:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(352);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(164);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(181);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(604);
	
	__webpack_require__(606);
	
	__webpack_require__(610);
	
	__webpack_require__(609);
	
	__webpack_require__(607);
	
	__webpack_require__(608);
	
	__webpack_require__(605);
	
	__webpack_require__(617);
	
	__webpack_require__(618);
	
	__webpack_require__(619);
	
	__webpack_require__(620);
	
	__webpack_require__(621);
	
	__webpack_require__(622);
	
	__webpack_require__(623);
	
	__webpack_require__(625);
	
	__webpack_require__(626);
	
	__webpack_require__(624);
	
	__webpack_require__(627);
	
	__webpack_require__(628);
	
	__webpack_require__(630);
	
	__webpack_require__(629);
	
	__webpack_require__(631);
	
	__webpack_require__(632);
	
	__webpack_require__(633);
	
	__webpack_require__(634);
	
	__webpack_require__(635);
	
	__webpack_require__(636);
	
	__webpack_require__(637);
	
	__webpack_require__(638);
	
	__webpack_require__(639);
	
	__webpack_require__(641);
	
	__webpack_require__(640);
	
	__webpack_require__(642);
	
	__webpack_require__(643);
	
	__webpack_require__(644);
	
	__webpack_require__(645);
	
	__webpack_require__(646);
	
	__webpack_require__(647);
	
	__webpack_require__(648);
	
	__webpack_require__(649);
	
	__webpack_require__(650);
	
	__webpack_require__(651);
	
	__webpack_require__(652);
	
	__webpack_require__(653);
	
	__webpack_require__(654);
	
	__webpack_require__(655);
	
	__webpack_require__(656);
	
	__webpack_require__(657);
	
	__webpack_require__(658);
	
	__webpack_require__(661);
	
	__webpack_require__(659);
	
	__webpack_require__(660);
	
	__webpack_require__(611);
	
	__webpack_require__(612);
	
	__webpack_require__(613);
	
	__webpack_require__(614);
	
	__webpack_require__(615);
	
	__webpack_require__(616);
	
	__webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Christian Travel for Couples | Love Song Couples Getaway",
	      meta: [{
	        name: "description",
	        content: "Check out this unique Christian Travel experience for couples " + "at The Ritz-Carlton, Cancun and The Ritz-Carlton, Kapalua in Maui!"
	      }, { name: "og:site_name", content: "Love Song Couples Getaway" }, { name: "og:image", content: "/images/facebookpreview.jpg" }, { name: "fb:admins", content: "100000663021171" }, { charSet: "utf-8" }, { httpEquiv: "X-UA-Compatible", content: "IE=edge" }, {
	        name: "viewport",
	        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
	      }, {
	        name: "cache-control",
	        content: "public, max-age=0, must-revalidate"
	      }, { name: "Pragma", content: "no-cache" }],
	      link: [{ rel: "icon", type: "image/x-icon", href: "/images/favicon.png" }, {
	        rel: "stylesheet",
	        href: "https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600"
	      }],
	      script: [{ src: "https://use.fontawesome.com/fda3474895.js" }, {
	        src: "//cdnjs.cloudflare.com/ajax/libs/classlist/2014.01.31/classList.min.js"
	      }, { src: "https://js.stripe.com/v3/" }, { src: "/js/app.js" }, { src: "/js/adroll.js" }]
	    }),
	    children()
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-e762ecb49a6b025f3e3b.js